"use client";

import { Button } from "@oreme/ui";
import Link from "next/link";
import React, { type ReactElement } from "react";

interface GlossaryNavItemProps {
  letter: string;
  counter?: number;
}

function GlossaryNavItem({
  letter,
  counter = 0,
}: Readonly<GlossaryNavItemProps>): ReactElement {
  if (counter) {
    return (
      <li className="uppercase font-semibold" key={`anchor-${letter}`}>
        <Link href={`#${letter}`}>
          <Button className="uppercase hover:cursor-pointer" variant="ghost">
            {letter}
          </Button>
        </Link>
      </li>
    );
  }

  return (
    <li className="uppercase font-semibold opacity-20" key={`anchor-${letter}`}>
      <Button className="uppercase" variant="ghost" disabled>
        {letter}
      </Button>
    </li>
  );
}

export { GlossaryNavItem, type GlossaryNavItemProps };
